module.exports = __webpack_public_path__ + "static/media/nunoPiresDeCarvalho.d8f8809c.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/nunoPiresDeCarvalho.jpg
// module id = 1581
// module chunks = 1